module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/cog-3e42a5a5e683d8bce9de0d5c786eb942.svg";